import { IonButton, IonContent, IonIcon, IonItem, IonLabel, IonPage, IonRow } from '@ionic/react';
import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { JobMessages } from '../../intl/JobMessages';
import DesktopHeader from 'src/components/reusable-components/desktop-header/DesktopHeader';
import React from 'react';
import { informationCircle } from 'ionicons/icons';
import { BundlesTableCard } from '../../components/bundles/bundle-table/BundlesTableCard';
import { FeatureGate } from '../../utils/feature-flags/FeatureFlags';
import { BundlesEmptyOrPaywallCard } from '../../components/bundles/BundlesEmptyOrPaywallCard';
import { downloadBundleTemplate } from '../../redux/api/bundles';
import { useSelector } from 'react-redux';
import { selectUserFeatureFlags } from '../../redux/auth/selectors';
import { DqText } from '../../components/dq-text';
import { BundleMessages } from '../../intl/BundleMessages';
import './BundlesListPage.scss';
import { AppRouteConstants } from '../app-layout/AppRouteConstants';
import { useToast } from 'src/components/reusable-components/useToast';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

export enum BundleListPageActions {
  'BundleDeletedSuccessful',
  'BundleDeleteFailed',
}
const BundlesListPage: FC = () => {
  document.title = englishOnlyIntl.formatMessage(JobMessages.bundlesTitle);
  useGA4();

  const { formatMessage } = useIntl();
  const [present] = useToast();

  const setToast = useCallback(
    (success: boolean, message: string, header?: string) => {
      present(
        {
          message,
        },
        success ? 'success' : 'danger',
      );
    },
    [present],
  );

  const handleDownload = React.useCallback(async () => {
    await downloadBundleTemplate();
  }, []);

  const isBundlesOn = useSelector(selectUserFeatureFlags)['BUNDLES'];

  return (
    <IonPage>
      <DesktopHeader title={formatMessage(JobMessages.bundlesTitle)} />
      <FeatureGate featureName={'BUNDLES'}>
        <IonContent>
          <BundleHelpButton />
          {isBundlesOn ? (
            <BundlesTableCard setToast={setToast} />
          ) : (
            <BundlesEmptyOrPaywallCard handleDownload={handleDownload} validPaidLicense={isBundlesOn} />
          )}
        </IonContent>
      </FeatureGate>
    </IonPage>
  );
};

export default BundlesListPage;

const BundleHelpButton: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <IonItem lines="none">
      {/** Inline style here to force IonIcon to drop extra margin on the right */}
      <IonIcon slot="start" icon={informationCircle} color="primary" className="learn-more-icon" />
      <IonLabel>
        <IonRow class="ion-text-wrap ion-justify-content-start ion-align-items-center">
          <DqText variant="h3"> {formatMessage(BundleMessages.bundleInfoHeader)}</DqText>
          <DqText variant="body-strong" className="learn-more-text">
            {formatMessage(BundleMessages.bundleInfoDescription)}
          </DqText>
          <IonButton fill="clear" routerLink={AppRouteConstants.BundleInstructions} className="learn-more-button">
            <DqText variant="body" className="learn-more-text">
              {formatMessage(BundleMessages.bundleInfoDescriptionLink)}
            </DqText>
          </IonButton>
        </IonRow>
      </IonLabel>
    </IonItem>
  );
};
